import { Grid, Link, Typography } from "@mui/material";
import { customColors, CustomColors } from "../../../styles/CustomColors";

interface CriteriaLinkProps {
  colors?: CustomColors;
}

const BottomCriteriaLinks = ({ colors = customColors }: CriteriaLinkProps) => {
  return (
    <Grid
      container
      component="section"
      role="region"
      aria-labelledby="bottom-links"
      aria-label="bottom-links"
      sx={{
        marginBottom: "1.875rem",
        lineHeight: "1.5",
        display: "block",
      }}
    >
      <Grid item>
        <Typography
          variant="body1"
          sx={{ margin: "0 0 1.875rem", textAlign: "center" }}
        >
          Learn more about the current{" "}
          <Link
            href={"https://www.energystar.gov/partner-resources/products_partner_resources/energy-star-most-efficient-"+import.meta.env.VITE_MOSTEFFICIENTYEAR+"-criteria"}
            underline="always"
            aria-label={"Current ENERGY STAR Most Efficient "+import.meta.env.VITE_MOSTEFFICIENTYEAR+" criteria"}
            sx={{
              color: colors.skyBlueBg,
              textDecorationColor: colors.skyBlueBg,
              "&:hover": {
                color: colors.skyBlueBg,
              },
            }}
            rel="noopener noreferrer"
          >
            ENERGY STAR Most Efficient {import.meta.env.VITE_MOSTEFFICIENTYEAR} criteria
          </Link>
          .
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body1" sx={{ margin: "0", textAlign: "center" }}>
          See previous criteria in the{" "}
          <Link
            href="https://www.energystar.gov/partner-resources/products_partner_resources/most-efficient-criteria-archive"
            underline="always"
            aria-label="ENERGY STAR Most Efficient Criteria Archive"
            sx={{
              color: colors.skyBlueBg,
              textDecorationColor: colors.skyBlueBg,
              "&:hover": {
                color: colors.skyBlueBg,
              },
            }}
            rel="noopener noreferrer"
          >
            ENERGY STAR Most Efficient Criteria Archive
          </Link>
          .
        </Typography>
      </Grid>
    </Grid>
  );
};

export default BottomCriteriaLinks;
